import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-web-tirewarranty-shared-ui-not-found',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './lib-not-found.component.html',
  styleUrl: './lib-not-found.component.scss',
})
export class LibNotFoundComponent {
  readonly router = inject(Router);

  goBack() {
    this.router.navigate(['/']);
  }
}
